import { type yup } from '@framework/validation/initYup.ts';
import { createEvaluationVariables } from '../../../../../expressions/evaluate/variables/IEvaluationVariables.ts';
import { type IReference } from '../../../../../expressions/references/IReference.ts';
import { type IAsyncValueWidget } from '../IAsyncValueWidget.ts';
import { buildAsyncServiceValidationTestFn } from './buildAsyncServiceValidationTestFn.ts';

/**
 * Imposta la regola per la validazione server-side del widget AsyncValue.
 */
export function getServerSideValidationSchema(
  schema: yup.AnySchema,
  params: {
    widget: IAsyncValueWidget;
    materializedReferences: {
      paths: string[];
      references: IReference[];
    };
    objectSchema: yup.ObjectSchema<yup.AnyObject>;
  },
) {
  const { widget, materializedReferences, objectSchema } = params;

  return schema.parentWhen(
    [
      '$trustedEnvironment',
      '$externalServiceContext',
      ...materializedReferences.paths,
    ],
    (data, schema) => {
      const [trustedEnvironment, externalServiceContext, ...inputValues] = data;
      const variables = createEvaluationVariables(
        materializedReferences.references,
        inputValues,
      );

      // Se non sono in un ambiente trusted, non applico la validazione (e.g. lato FE)
      if (!trustedEnvironment) return schema;

      // In questo test vado a richiamare il servizio e a valutare che tutti i campi
      // del risultato coincidano con quelli attesi, altrimenti ritorno false
      return schema.test({
        name: 'async-value-validation',
        message: 'Valore non valido secondo il servizio esterno',
        exclusive: true,
        test: buildAsyncServiceValidationTestFn(
          externalServiceContext,
          widget,
          variables,
          objectSchema,
        ),
      });
    },
  );
}
